<div class="app-loader" *ngIf="loading && !isUnderMaintainance">
    <div class="loader-spinner"></div>
    <div class="loader-text">Loading...</div>
</div>

<div class="container mt-100" *ngIf="!loading && !isUnderMaintainance">
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 mx-auto">
            <div class="card shadow" *ngIf="displayErrMsg != null && enableMfas?.targetUrl == null">
                <div class="card-body pt-5 pb-5 px-20">
                    <p class="pt-5 pb-5"> {{displayErrMsg}} </p>
                </div>
            </div>
            <div class="card shadow" *ngIf="enableMfas?.targetUrl != null">
                <div class="card-body p-20 pb-0">
                    {{enableMfas.displayMessage}}
                </div>
            </div>
            <div class="card shadow" *ngIf="displayErrMsg == null && enableMfas?.targetUrl == null">
                <div class="card-body p-20 pb-0" *ngIf="!loading && enableMfas?.error == null">
                    <div class="row">
                        <div class="col-lg-2">
                            <img style="object-fit: contain;" src="../../assets/images/logo-dummy.png" height="80"
                                width="150" alt="" *ngIf="!enableMfas?.logo">
                            <img style="object-fit: contain;" src="{{enableMfas?.logo}}" height="80" width="150" alt=""
                                *ngIf="enableMfas?.logo">
                        </div>
                        <div class="col-lg-10 text-center">
                            <p class="fs-22 d-inline-flex"> <span class="material-icons text-danger fs-30">
                                    report
                                </span> &nbsp;Access to the application requires a Multi-Factor Authentication.</p>
                        </div>
                    </div>
                    <div *ngIf="isShowInstructionsToUpgrade && !isNewDeviceRegistered">
                        <h5 class="mb-2 mt-3">Important Instructions</h5>
                        <ul class="mb-0">
                            <li><strong>Min Security App</strong> has been renamed to <strong>Min
                                    Authenticator</strong>. It is now available on both the <strong>App Store</strong>
                                and <strong>Play Store</strong>.</li>

                            <li>To continue using Multi-Factor Authentication (MFA):</li>
                        </ul>

                        <ul class="nav nav-tabs mb-3" id="authTab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" id="ios-tab" data-toggle="tab" href="#ios" role="tab"
                                    aria-controls="ios" aria-selected="true">
                                    iOS
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="android-tab" data-toggle="tab" href="#android" role="tab"
                                    aria-controls="android" aria-selected="false">
                                    Android
                                </a>
                            </li>
                        </ul>


                        <div class="tab-content" id="authTabContent">
                            <div class="tab-pane fade show active" id="ios" role="tabpanel" aria-labelledby="ios-tab">
                                <div class="row align-items-start mb-4">
                                    <div class="col-md-2">
                                        <img src="../../assets/images/AppStoreQRCode.png" alt="iOS QR Code"
                                            class="img-fluid" />
                                    </div>
                                    <div class="col-md-10">
                                        <p><strong>For iOS users:</strong></p>
                                        <p>Open the <em>App Store</em>, search for <strong>“Min Authenticator”</strong>,
                                            and tap <em>Download</em> to install the app.</p>
                                        <p>Or scan the QR code to go directly to the app.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="android" role="tabpanel" aria-labelledby="android-tab">
                                <div class="row align-items-start mb-4">
                                    <div class="col-md-2">
                                        <img src="../../assets/images/PlayStoreQRCode.png" alt="Android QR Code"
                                            class="img-fluid" />
                                    </div>
                                    <div class="col-md-10">
                                        <p><strong>For Android users:</strong></p>
                                        <p>Open the <em>Google Play Store</em>, search for <strong>“Min
                                                Authenticator”</strong>, and tap <em>Install</em> to get the app.</p>
                                        <p>Or scan the QR code to go directly to the app.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p>1. Click the button below to receive device enrollment instructions via email.</p>
                        <button class="btn btn-primary px-4 mb-3" (click)="enrollNew()">Send Device Enrollment
                            Instructions</button>
                        <p class="text-primary" *ngIf="emailSent">{{ emailSent }}</p>

                        <p>2. Once you receive the email, scan the QR code using the Min Authenticator app to complete
                            the registration.
                        </p>
                        <div class=" text-right mb-3">
                            <button class="btn btn-outline-primary" (click)="closeInstructions('skip')">Skip</button>
                            <button class="btn mx-2 btn-primary px-4" (click)="closeInstructions('ok')">Ok</button>
                        </div>
                    </div>
                    <div *ngIf="!isShowInstructionsToUpgrade && isNewDeviceRegistered">
                        <h6 class="text-secondary pb-6 px-0 pt-15 d-flex">Registered Devices
                            <span class="material-icons pointer text-primary ml-10 fs-18" title="edit"
                                (click)="addDevice(adddevice)">
                                edit
                            </span>
                            <span class="ml-30 d-flex pointer" (click)="getUserDevices('refresh')">
                                <span class="material-icons pointer fs-18 text-secondary" title="edit">
                                    refresh
                                </span> &nbsp; Get Devices
                            </span>
                        </h6>
                        <span class="fs-18" *ngIf="userDevices.length == 0"> None </span>
                        <button class="btn"
                            [ngStyle]="{background: enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, color: '#fff'}"
                            *ngIf="userDevices.length == 0" (click)="addDevice(adddevice)">Register New Device</button>
                        <div class="card  p-0 m-0" *ngIf="userDevices.length != 0">
                            <div class="card-body p-0 m-0">
                                <div class="form-group p-0 m-0">
                                    <select name="" id="" class="form-control" (change)="chnageDeviceDetails()"
                                        [(ngModel)]="selectedDeviceId" title="Select Device">
                                        <option value="{{item?.deviceId}}" *ngFor="let item of userDevices">
                                            {{item?.deviceName}} <span
                                                *ngIf="item?.phoneNumber != null && item?.phoneNumber != ''"> &nbsp;
                                                &nbsp;
                                                ({{item?.phoneNumber}})</span> </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 mb-4 px-0 pt-20">
                            <p class="fs-17">Please choose <b>one</b> of the below Authentication factors</p>
                            <div class="row">
                                <!-- <div class="col-lg-11 col-md-12 col-sm-12 mx-auto">
                                    <div class="row"> -->
                                <div class="col-sm-4 col-md-4 col-lg-3 col-xs-12 pt-10"
                                    *ngIf="enableMfas?.OptionsGroupDTO?.pushFrEnabled && userDevices?.length != 0">
                                    <div class="card shadow h-100 mh-250">
                                        <div class="card-body pt-2 text-center">
                                            <span class="material-icons  fs-40"
                                                [ngStyle]="{color: enableMfas?.mfaOptionsColorFontThemeDTO?.iconColor}">
                                                face
                                            </span>
                                            <h4 class="fs-17 font-weight-bold"
                                                [ngStyle]="{color: enableMfas?.mfaOptionsColorFontThemeDTO?.fontColor}">
                                                Face
                                                Recognition</h4>
                                            <div class="align-items-center push-button px-15" (mouseover)="hover=true"
                                                (mouseleave)="hover1=false" (mouseover)="hover=true">
                                                <!-- <div class="mfa-button py-1 fs-14" [ngStyle]="{border:'1px solid' + enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, color: hover == true  ? '#fff' : enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, backgroundColor: hover == true  ? enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor : '#fff'}"
                                                    (click)="sendPush('face', content)">Send Me
                                                    A Push</div> -->
                                                <div class="align-items-center push-button px-15"
                                                    (mouseover)="hover=true" (mouseleave)="hover=false">
                                                    <div class="mfa-button py-1 fs-14"
                                                        [ngStyle]="{border:'1px solid' + enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, color: hover == true  ? '#fff' : enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, backgroundColor: hover == true  ? enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor : '#fff'}"
                                                        (click)="sendPush('face', content)">Send Me A Push</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4 col-md-4 col-lg-3 col-xs-12  pt-10"
                                    *ngIf="enableMfas?.OptionsGroupDTO?.pushFpEnabled && userDevices?.length != 0">
                                    <div class="card shadow h-100 mh-250">
                                        <div class="card-body pt-2 text-center">
                                            <span class="material-icons  fs-40"
                                                [ngStyle]="{color: enableMfas?.mfaOptionsColorFontThemeDTO?.iconColor}">
                                                fingerprint
                                            </span>
                                            <h4 class="fs-17 font-weight-bold"
                                                [ngStyle]="{color: enableMfas?.mfaOptionsColorFontThemeDTO?.fontColor}">
                                                Finger Print</h4>
                                            <!-- <div class="align-items-center push-button px-15"  (mouseover)="hove1r=true" (mouseleave)="hover1=false">
                                                 <div class="mfa-button py-1 fs-14"
                                                    (click)="sendPush('fingerPrint', content)" [ngStyle]="{border:'1px solid' + enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, color: hover1 == true  ? '#fff' : enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, backgroundColor: hover1 == true  ? enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor : '#fff'}">Send Me A
                                                    Push</div>
                                            </div> -->
                                            <div class="align-items-center push-button px-15" (mouseover)="hover1=true"
                                                (mouseleave)="hover1=false">
                                                <div class="mfa-button py-1 fs-14"
                                                    [ngStyle]="{border:'1px solid' + enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, color: hover1 == true  ? '#fff' : enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, backgroundColor: hover1 == true  ? enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor : '#fff'}"
                                                    (click)="sendPush('fingerPrint', content)">Send Me A Push</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4 col-md-4 col-lg-3 col-xs-12   pt-10"
                                    *ngIf="enableMfas?.OptionsGroupDTO?.isEmailEnabled">
                                    <div class="card shadow h-100 mh-250">
                                        <div class="card-body pt-2 text-center">
                                            <span class="material-icons  fs-40"
                                                [ngStyle]="{color: enableMfas?.mfaOptionsColorFontThemeDTO?.iconColor}">
                                                mail
                                            </span>
                                            <h4 class="fs-17 font-weight-bold"
                                                [ngStyle]="{color: enableMfas?.mfaOptionsColorFontThemeDTO?.fontColor}">
                                                Email</h4>
                                            <div class="align-items-center push-button px-15" (mouseover)="hover2=true"
                                                (mouseleave)="hover2=false">
                                                <div class="mfa-button py-1 fs-14"
                                                    [ngStyle]="{border:'1px solid' + enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, color: hover2 == true  ? '#fff' : enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, backgroundColor: hover2 == true  ? enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor : '#fff'}"
                                                    (click)="sendPush('email', content)">Email The Passcode</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4 col-md-4 col-lg-3 col-xs-12  pt-10"
                                    *ngIf="enableMfas?.OptionsGroupDTO?.yubicoOtpEnabled || enableMfas?.OptionsGroupDTO?.yubicoFidoEnabled">
                                    <div class="card shadow h-100 mh-250">
                                        <div class="card-body pt-2 text-center">
                                            <img src="../../assets/images/Yubico.svg" alt="minpin" height="50"
                                                [ngStyle]="{color: enableMfas?.mfaOptionsColorFontThemeDTO?.iconColor}">
                                            <h4 class="fs-17 font-weight-bold"
                                                [ngStyle]="{color: enableMfas?.mfaOptionsColorFontThemeDTO?.fontColor}">
                                                YubiKey</h4>
                                            <div class="align-items-center push-button px-15" (mouseover)="hover22=true"
                                                (mouseleave)="hover22=false">
                                                <!-- <div class="mfa-button py-1 fs-14" [ngStyle]="{border:'1px solid' + enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, color: hover22 == true  ? '#fff' : enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, backgroundColor: hover22 == true  ? enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor : '#fff'}"
                                                    (click)="sendPush('yubicoFido2', content)">Authenticate</div> -->
                                                <div ngbDropdown placement="bottom">
                                                    <div id="dropdownBasic2" ngbDropdownToggle> <a
                                                            href="javascript:void(0)">
                                                            <div class="mfa-button py-1 fs-14"
                                                                [ngStyle]="{border:'1px solid' + enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, color: hover22 == true  ? '#fff' : enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, backgroundColor: hover22 == true  ? enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor : '#fff'}">
                                                                Authenticate</div>
                                                        </a></div>
                                                    <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
                                                        <button ngbDropdownItem
                                                            (click)="sendPush('yubicoFido2', content)">Authenticate</button>
                                                        <button ngbDropdownItem>Register a new YubiKey</button>
                                                        <button ngbDropdownItem (click)="requestLogin(loginRequest)"
                                                            *ngIf="enableMfas?.isForgotYubicoEnable">Forgot
                                                            Yubikey</button>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4 col-md-4 col-lg-3 col-xs-12  pt-10"
                                    *ngIf="enableMfas?.OptionsGroupDTO?.phoneCallEnabled">
                                    <div class="card shadow h-100 mh-250">
                                        <div class="card-body pt-2 text-center">
                                            <span class="material-icons  fs-40"
                                                [ngStyle]="{color: enableMfas?.mfaOptionsColorFontThemeDTO?.iconColor}">
                                                phone_in_talk
                                            </span>
                                            <h4 class="fs-17 font-weight-bold"
                                                [ngStyle]="{color: enableMfas?.mfaOptionsColorFontThemeDTO?.fontColor}">
                                                Phone Call</h4>
                                            <div class="align-items-center push-button px-15" (mouseover)="hover4=true"
                                                (mouseleave)="hover4=false">
                                                <div class="mfa-button py-1 fs-14"
                                                    (click)="sendPush('phoneCall', content)"
                                                    [ngStyle]="{border:'1px solid' + enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, color: hover4 == true  ? '#fff' : enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, backgroundColor: hover4 == true  ? enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor : '#fff'}">
                                                    Call me</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4 col-md-4 col-lg-3 col-xs-12  pt-10"
                                    *ngIf="enableMfas?.OptionsGroupDTO?.smsEnabled">
                                    <div class="card shadow h-100 mh-250">
                                        <div class="card-body pt-2 text-center">
                                            <span class="material-icons  fs-40"
                                                [ngStyle]="{color: enableMfas?.mfaOptionsColorFontThemeDTO?.iconColor}">
                                                message
                                            </span>
                                            <h4 class="fs-17 font-weight-bold"
                                                [ngStyle]="{color: enableMfas?.mfaOptionsColorFontThemeDTO?.fontColor}">
                                                Text-Message</h4>
                                            <div class="align-items-center push-button px-15" (mouseover)="hover5=true"
                                                (mouseleave)="hover5=false">
                                                <div class="mfa-button py-1 fs-14" (click)="sendPush('otp', content)"
                                                    [ngStyle]="{border:'1px solid' + enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, color: hover5 == true  ? '#fff' : enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, backgroundColor: hover5 == true  ? enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor : '#fff'}">
                                                    Send SMS</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4 col-md-4 col-lg-3 col-xs-12  pt-10"
                                    *ngIf="enableMfas?.OptionsGroupDTO?.otpEnabled && userDevices?.length != 0">
                                    <div class="card shadow h-100 mh-250">
                                        <div class="card-body pt-2 text-center">
                                            <span class="material-icons  fs-40"
                                                [ngStyle]="{color: enableMfas?.mfaOptionsColorFontThemeDTO?.iconColor}">
                                                more_horiz
                                            </span>
                                            <!-- <img src="../../assets/images/minpin.png" alt="minpin" height="50"> -->
                                            <h4 class="fs-17 font-weight-bold"
                                                [ngStyle]="{color: enableMfas?.mfaOptionsColorFontThemeDTO?.fontColor}">
                                                Min
                                                App Passcode</h4>
                                            <div class="align-items-center push-button px-15" (mouseover)="hover6=true"
                                                (mouseleave)="hover6=false">
                                                <div class="mfa-button py-1 fs-14" (click)="sendPush('minPin', content)"
                                                    [ngStyle]="{border:'1px solid' + enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, color: hover6 == true  ? '#fff' : enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, backgroundColor: hover6 == true  ? enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor : '#fff'}">
                                                    Passcode on Min App</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4 col-md-4 col-lg-3 col-xs-12  pt-10"
                                    *ngIf="enableMfas?.OptionsGroupDTO?.pushYnEnabled && userDevices?.length != 0">
                                    <div class="card shadow h-100 mh-250">
                                        <div class="card-body pt-2 text-center">
                                            <span class="material-icons  fs-40"
                                                [ngStyle]="{color: enableMfas?.mfaOptionsColorFontThemeDTO?.iconColor}">
                                                settings_cell
                                            </span>
                                            <h4 class="fs-17 font-weight-bold"
                                                [ngStyle]="{color: enableMfas?.mfaOptionsColorFontThemeDTO?.fontColor}">
                                                min
                                                Prompt</h4>
                                            <div class="align-items-center push-button px-15" (mouseover)="hover7=true"
                                                (mouseleave)="hover7=false">
                                                <div class="mfa-button py-1 fs-14"
                                                    (click)="sendPush('minPrompt', content)"
                                                    [ngStyle]="{border:'1px solid' + enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, color: hover7 == true  ? '#fff' : enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, backgroundColor: hover7 == true  ? enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor : '#fff'}">
                                                    Send Me A
                                                    Push</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf=" !isShowInstructionsToUpgrade && !isNewDeviceRegistered">
                        <h5 class="text-secondary pb-6 px-0 pt-15">No Device Registered</h5>
                        <button class="btn btn-primary" (click)="addDevice(adddevice)">Register New Device</button>
                        <p class="fs-17">Please choose <b>one</b> of the below Authentication factors</p>
                        <div class="col-sm-4 col-md-4 col-lg-3 d-fex pt-10"
                            *ngIf="enableMfas?.OptionsGroupDTO?.isEmailEnabled">
                            <div class="card shadow h-100 mh-250">
                                <div class="card-body pt-2 text-center">
                                    <span class="material-icons  fs-40"
                                        [ngStyle]="{color: enableMfas?.mfaOptionsColorFontThemeDTO?.iconColor}">
                                        mail
                                    </span>
                                    <h4 class="fs-17 font-weight-bold"
                                        [ngStyle]="{color: enableMfas?.mfaOptionsColorFontThemeDTO?.fontColor}">
                                        Email</h4>
                                    <div class="align-items-center push-button px-15" (mouseover)="hover2=true"
                                        (mouseleave)="hover2=false">
                                        <div class="mfa-button py-1 fs-14"
                                            [ngStyle]="{border:'1px solid' + enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, color: hover2 == true  ? '#fff' : enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, backgroundColor: hover2 == true  ? enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor : '#fff'}"
                                            (click)="sendPush('email', content)">Email The Passcode</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card-body" *ngIf="enableMfas?.error && !loading">
                        <div class="row">
                            <div class="col-sm-6">
                                <img src="{{enableMfas?.logo}}" alt="" height="80">
                            </div>
                            <div class="col-sm-6">
                                <i class="text-primary fs-36 float-right">min</i>
                            </div>
                            <div class="col-sm-12 py-20 fs-18">
                                {{enableMfas?.error?.title}}
                            </div>
                            <div class="col-sm-12 fs-18">
                                {{enableMfas?.error?.displayMessage}}
                            </div>
                        </div>
                    </div>
                    <div class="card-footer text-center bg-white" *ngIf="!loading">
                        Powered by <i class="text-primary fs-18"> min </i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="isUnderMaintainance">
    <nav class="navbar navbar-expand-lg bg-white navbar-light shadow sticky-top p-0">
        <div class="navbar-brand d-flex align-items-center px-4 px-lg-4 brand-logo">
            <img src="../../../assets/img/logoecorp.png" class="p-4" alt="">
        </div>
    </nav>

    <div class="error-404">
        <div class="error-code m-b-10 m-t-20">503 <i class="fa fa-warning"></i></div>
        <h2 class="font-bold">503 Service Unavailable</h2>

        <div class="error-desc">
            Our website is currently undergoing scheduled maintenance.<br> We apologize for any inconvenience this may
            cause
            and
            appreciate your patience.<br>
            Please try again later.

            <div><br />
                <!-- <a class=" login-detail-panel-button btn" href="http://vultus.de/"> -->
                <button [routerLink]="['/login']" routerLinkActive="router-link-active" class="btn btn-primary"><span
                        class="glyphicon glyphicon-home"></span> Go back to
                    login </button> <br><br>
                <strong>Or</strong> <br><br>
                <button (click)="reload()" class="btn btn-outline-primary"><span
                        class="glyphicon glyphicon-home"></span>
                    Reload
                </button>


            </div>
        </div>
    </div>
</div>



<ng-template #content let-modal>
    <div class="card-body" *ngIf="processing">
        <p class="text-center">
            <img src="../../../assets/images/spinner.gif" alt="" height="200px">
        </p>
    </div>
    <div *ngIf="!processing">
        <div class="card-body" *ngIf="ShowOtpScreen">
            <div class="col-lg-12 text-center">
                <h2 class="logo text-primary font-weight-bold"><i>min</i></h2>
            </div>
            <div class="col-lg-12"
                *ngIf="(pushType == 'otp' ||  pushType == 'email' || pushType == 'yubicoFido2') && !isPushNotificationsEnabled">
                <h4 class="small font-weight-bold py-10 fs-16">{{mfaResponce?.message}}</h4>
                <p *ngIf="pushType == 'yubicoFido2'">1.Insert your Yubikey into a USB port</p>
                <p *ngIf="pushType == 'yubicoFido2'">2.Mouse over to the Yubico OTP field below, and touch the
                    Yubikey button</p>
                <div class="form-group" *ngIf="pushType == 'yubicoFido2'">
                    <label for="otp">Yubico OTP</label>
                    <input type="text" placeholder="Yubico OTP" name="otp" [(ngModel)]="otp" class="form-control"
                        autofocus id="myText" (keydown)="enterKey($event)">
                </div>
                <div class="form-group" *ngIf="pushType != 'yubicoFido2'">
                    <label for="otp">Verification Code</label>
                    <input type="text" placeholder="Enter verification code" name="otp" [(ngModel)]="otp"
                        class="form-control" id="otp" (keydown)="enterKey($event)">
                </div>
                <span *ngIf="pushType != 'yubicoFido2'"> Verification code will expires in {{counter}} seconds
                </span>
            </div>
            <div class="col-lg-12" *ngIf="pushType == 'minPin'">
                <div class="form-group">
                    <label for="otp">Enter The Passcode</label>
                    <input type="text" placeholder="As shown on the dashboard of min app" name="otp" [(ngModel)]="otp"
                        class="form-control" id="otp" (keydown)="enterKey($event)">
                </div>
            </div>
        </div>
        <div class="card-body text-center"
            *ngIf="pushNotificationScreen && !isTimeExpired && !isPushNotificationsEnabled && !isFailedPushNotificationSent && !ShowOtpScreen">
            <div class="col-lg-12">
                <h2 class="logo text-primary font-weight-bold"><i>min</i></h2>
            </div>
            <div *ngIf="!yubicoManagerAccessRequestScreen">
                <p class="font-weight-bold pb-20 fs-16 pb-0" *ngIf="pushType != 'phoneCall'">{{displayOptionType}}
                    push
                    notification sent
                    to your <i>min</i> app. Please
                    check your {{selectedDeviceName}} Mobile. </p>
                <p class="font-weight-bold pb-20 fs-15 pb-0" *ngIf="pushType == 'phoneCall'">
                    {{mfaResponce?.message}} <br>
                    Answer the Phone, hear the message and press 1 to agree to get access to the application.
                </p>
                <p class="text-muted">Please Don't press back button or refresh.</p>
                <p *ngIf="pushType != 'phoneCall'">
                    <span class="text-secondary pointer" (click)="resendPush()">Click here</span> to Resend Push
                    Notification
                </p>
            </div>
        </div>
        <div class="card-body text-center" *ngIf="yubicoManagerAccessRequestScreen">
            <h3 class="text-primary">Approval Request</h3>
            <div *ngIf="displayWaringMessage == null">
                <p class="font-weight-bold py-20 fs-16 pb-0">Request sent to your manager. Please wait for a few
                    mins until he approves. We will also notify you by email upon approval. Thank you! </p>
                <p class="text-muted">Please Don't press back button or refresh.</p>
                <p>
                    <span class="text-secondary pointer" (click)="resendPush()">Click here</span> to Resend approval
                    request
                </p>
            </div>
            <div *ngIf="displayWaringMessage">
                {{displayWaringMessage}}
            </div>
        </div>
        <div class="card-body text-left"
            *ngIf="pushNotificationScreen && (isTimeExpired || isPushNotificationsEnabled || isFailedPushNotificationSent)">
            <p class="fs-20" *ngIf="isTimeExpired">
                It’s been a minute, and we don’t see a response.<br> <br>
                Please ensure that Your device is: <br>
                - Not switched off and is reachable.<br>
                - Registered and has an active Min APP <br> <br>
                To get going: <br>
                You can as well cancel and choose other alternative MFA options to authenticate.
            </p>
            <p class="fs-20" *ngIf="isPushNotificationsEnabled">
                To use {{displayOptionType}} as an option, you will have to enable Push Notifications for the Min
                APP by
                following below instructions:<br><br>
                Navigate to Setting and Select Min App, select Allow Push Notifications, and Launch Min App on your
                device and try again.
            </p>
            <p class="fs-20" *ngIf="isFailedPushNotificationSent">
                Unable to send the {{displayOptionType}} notification <br>
                please ensure the Min app is installed and registered on {{selectedDeviceName}} and try again
            </p>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline" *ngIf="!displayWaringMessage"
                (click)="close()">Cancel</button>
            <button type="button" class="btn btn-outline" *ngIf="displayWaringMessage" (click)="getUserDevices()"
                (click)="close()">Ok</button>
            <button class="btn btn-primary" (click)="validateOTP()" *ngIf="ShowOtpScreen">Submit</button>
        </div>
    </div>
</ng-template>





<ng-template #adddevice let-modal>
    <div class="modal-header">
        <h4 class="modal-title" [ngStyle]="{color: enableMfas?.mfaOptionsColorFontThemeDTO?.fontColor}">Edit Device
            Information</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="card-body fs-17">
        <div *ngIf="isDeviceExists">
            <h5 class="mb-2 mt-3">Important Instructions</h5>
            <ul class="mb-0">
                <li><strong>Min Security App</strong> has been renamed to <strong>Min
                        Authenticator</strong>. It is now available on both the <strong>App Store</strong>
                    and <strong>Play Store</strong>.</li>

                <li>To continue using Multi-Factor Authentication (MFA):</li>
            </ul>
        </div>

        <h5 class="text-secondary pb-10" *ngIf="!isDeviceExists">New Device registration will require you to follow the
            below steps</h5>
        <!-- Nav Tabs -->
        <ul class="nav nav-tabs mb-3" id="authTab" role="tablist">
            <li class="nav-item">
                <a class="nav-link active" id="ios-tab" data-toggle="tab" href="#ios" role="tab" aria-controls="ios"
                    aria-selected="true">
                    iOS
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" id="android-tab" data-toggle="tab" href="#android" role="tab"
                    aria-controls="android" aria-selected="false">
                    Android
                </a>
            </li>
        </ul>

        <!-- Tab Panes -->
        <div class="tab-content" id="authTabContent">
            <!-- iOS Tab -->
            <div class="tab-pane fade show active" id="ios" role="tabpanel" aria-labelledby="ios-tab">
                <div class="row align-items-start mb-4">
                    <div class="col-md-2">
                        <img src="../../assets/images/AppStoreQRCode.png" alt="iOS QR Code" class="img-fluid" />
                    </div>
                    <div class="col-md-10">
                        <p><strong>For iOS users:</strong></p>
                        <p>Open the <em>App Store</em>, search for <strong>“Min Authenticator”</strong>, and tap
                            <em>Download</em> to install the app.
                        </p>
                        <p>Or scan the QR code to go directly to the app.</p>
                    </div>
                </div>
            </div>

            <!-- Android Tab -->
            <div class="tab-pane fade" id="android" role="tabpanel" aria-labelledby="android-tab">
                <div class="row align-items-start mb-4">
                    <div class="col-md-2">
                        <img src="../../assets/images/PlayStoreQRCode.png" alt="Android QR Code" class="img-fluid" />
                    </div>
                    <div class="col-md-10">
                        <p><strong>For Android users:</strong></p>
                        <p>Open the <em>Google Play Store</em>, search for <strong>“Min Authenticator”</strong>, and tap
                            <em>Install</em> to get the app.
                        </p>
                        <p>Or scan the QR code to go directly to the app.</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Enrollment Instructions -->
        <p>1. Click the button below to receive device enrollment instructions via email.</p>
        <button class="btn btn-primary px-4 mb-3" (click)="enrollNew()">Send Device Enrollment Instructions</button>
        <p class="text-primary" *ngIf="emailSent">{{ emailSent }}</p>

        <p>2. Once you receive the email, scan the QR code using the Min Authenticator app to complete the registration.
        </p>
        <p>3. As a best practice, please remove any devices listed below that you no longer use.</p>

        <table class="table table-striped table-responsive w-100">
            <tbody *ngFor="let item of userDevices">
                <tr>
                    <th scope="row">{{item?.deviceName}}</th>
                    <td><button class="btn btn-outline" (click)="updateDeviceName(item)"
                            *ngIf="!item?.defaultDevice">Make It default</button>
                        <span class="badge badge-info" *ngIf="item?.defaultDevice">Current Default Device</span>
                    </td>
                    <td>
                        <div class="btn-group" role="group" aria-label="Basic example">
                            <button type="button" class="btn btn-info btn-sm"
                                (click)="editDeviceName(editdeviceName, item?.deviceId)">
                                <span class="material-icons">edit</span></button>
                            <button type="button" class="btn btn-danger btn-sm"
                                (click)="deleteUserDevice(item?.deviceId)"> <span
                                    class="material-icons">delete</span></button>
                        </div>
                    </td>
                </tr>

            </tbody>
        </table>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn px-30"
            [ngStyle]="{background: enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, color: '#fff'}"
            (click)="getUserDevices()" (click)="modal.dismiss('Cross click')">Ok</button>
        <span (mouseover)="hoverfooter=true" (mouseleave)="hoverfooter=false" (mouseover)="hover=true">
            <button type="button" class="btn px-30"
                [ngStyle]="{border:'1px solid' + enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, color: hoverfooter == true  ? '#fff' : enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor, backgroundColor: hoverfooter == true  ? enableMfas?.mfaOptionsColorFontThemeDTO?.buttonColor : '#fff'}"
                (click)="modal.dismiss('Cross click')">Cancel</button>
        </span>
    </div>
</ng-template>



<ng-template #editdeviceName let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Edit Device Name</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="card-body fs-17">
        <div class="form-group">
            <label for="devoiceName">Device Name</label>
            <input type="text" class="form-control" [(ngModel)]="deviceName" name="deviceName">
        </div>
        <div class="form-group form-check pl-0">
            <input type="checkbox" class="form-check-input" id="defaultDevice" [(ngModel)]="defaultDevice">
            <label class="form-check-label" for="defaultDevice">
                Make As Default Device
            </label>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary px-30" (click)="updateDeviceName(null)">Update</button>
        <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">Cancel</button>
    </div>
</ng-template>
<div class="modal fade" id="locationPermissionModal" tabindex="-1" role="dialog"
    aria-labelledby="locationPermissionModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content p-3">
            <div class="modal-header">
                <h5 class="modal-title" id="locationPermissionModalLabel">Enable Location Access</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>This app requires your location to work correctly. It looks like location access has been blocked.
                </p>
                <p><strong>To enable location access:</strong></p>
                <ul>
                    <li>Click the controls icon next to the address bar</li>
                    <li>Choose <strong>“Site settings”</strong> or locate the <strong>Location</strong> permission</li>
                    <li>Set <strong>Location</strong> to <strong>"Allow"</strong></li>
                    <li>Refresh the page</li>
                </ul>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close"
                    (click)="closeModal()">Ok</button>
            </div>
        </div>
    </div>
</div>
<ng-template #loginRequest let-modal>
    <div class="card-body" *ngIf="processing">
        <p class="text-center">
            <img src="../../../assets/images/spinner.gif" alt="" height="200px">
        </p>
    </div>
    <div *ngIf="!processing && isManagerAccessRequired">
        <div class="modal-header">
            <h4 class="modal-title">Login Request</h4>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="card-body fs-17">
            <div class="form-group">
                <label for="devoiceName">Select Manager</label>
                <select type="text" class="form-control" [(ngModel)]="userManagerId" name="yubicoManagerAccessRequest">
                    <option value="{{item.id}}" *ngFor="let item of managersList"
                        [disabled]="!item?.isAcceptingRequest">{{item.name}}
                        <span *ngIf="!item?.isAcceptingRequest">(Currently not accepting request)</span>
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label for="devoiceName">Message</label>
                <textarea name="message" id="" cols="6" placeholder="Type a note for your manager" rows="6"
                    class="form-control" [(ngModel)]="requestReason"></textarea>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary px-30"
                (click)="sendPush('yubicoManagerAccessRequest', content)" [disabled]="!userManagerId">Request</button>
            <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">Cancel</button>
        </div>
    </div>
    <div class="card-body" *ngIf="!processing && !isManagerAccessRequired">
        <p>You have manager approval to login. you will login in 2 secs</p>
        <p class="text-muted">Please Don't press back button or refresh.</p>
    </div>
</ng-template>